import { IoIosPin } from "react-icons/io";
import { CiClock1 } from "react-icons/ci";
import { MdOutlineSupportAgent } from "react-icons/md";

export const benefits = [
    {
        icon: <IoIosPin size={28} />,
        title: "Cobertura en Zonas Rurales",
        description: "Llevamos conectividad a donde otros no llegan",
    },
    {
        icon: <CiClock1 size={28} />,
        title: "Atención Personalizada",
        description: "Servicio al cliente dedicado y especializado",
    },
    {
        icon: <MdOutlineSupportAgent size={28} />,
        title: "Soporte Técnico 24/7",
        description: "Asistencia remota y presencial cuando lo necesites",
    },
]

